<div class="financial-dashboard-container  mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <!-- Header -->
  <div class="row mb-2">
    <div class="col-md-12 col-sm-12">
      <div class="p-3 rounded-3 border bg-light h-100">
        <div class="text-muted d-flex align-items-center gap-2 dashboard-title">
          <i class="bi bi-graph-up-arrow"></i>
          Financial Dashboard
        </div>
        <div class="text-muted small mt-1">
          Real-time financial monitoring and analysis.
        </div>
      </div>
    </div>
  </div>

  <!-- Bank Account Overview (prod only) -->
  @if (isProd && accountData) {
    <app-contributor-account-details [data]="accountData"></app-contributor-account-details>
  }

  <!-- Date Range Filter -->
  <div class="filter-section">
    <h5 class="filter-title">Filter by Date Range</h5>
    <div class="filter-controls">
      <div class="form-group">
        <label for="startDate">Start Date</label>
        <input type="date" class="form-control" id="startDate" [(ngModel)]="startDate" [max]="maxStartDate"
          (change)="onStartDateChange()">
      </div>
      <div class="form-group">
        <label for="endDate">End Date</label>
        <input type="date" class="form-control" id="endDate" [(ngModel)]="endDate" [min]="minEndDate"
          [max]="maxStartDate" [disabled]="!startDate">
      </div>
      <div class="form-group button-group">
        <button class="btn btn-primary" (click)="onFilterApply()" [disabled]="!startDate || !endDate">
          Apply Filter
        </button>
        <button class="btn btn-secondary" (click)="onFilterReset()">
          Reset to Current Month
        </button>
      </div>
    </div>
  </div>

  <!-- Fund Usage Warnings -->
  @if (hasFundWarnings) {
  <div class="alert alert-warning alert-dismissible fade show" role="alert">
    <h5 class="alert-heading">
      <i class="bi bi-exclamation-triangle-fill"></i> Fund Limit Exceeded
    </h5>
    <p class="mb-0">
      Your fund has exceeded the limit on <strong>{{ fundWarningsCount }}</strong>
      {{ fundWarningsCount === 1 ? 'day' : 'days' }} this month.
    </p>
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
  }

  <!-- Dashboard Tiles -->
  @if (summary) {
  <div class="dashboard-tiles">
    <div class="row">

      <!-- Total Credit Pool -->
      <div class="col-md-3">
        <div class="dashboard-tile card-glow">
          <div class="tile-label">Total Credit Pool</div>
          <div class="tile-value">{{ formatCurrency(summary.totalCreditPool) }}</div>
          <div class="buffer-info">
            <div class="buffer-row">
              <span class="buffer-label">Buffer Percentage</span>
              <span class="buffer-separator">:</span>
              <span class="buffer-value">{{ formatPercentage(summary.bufferPercentage) }}</span>
            </div>
            <div class="buffer-row">
              <span class="buffer-label">Buffer Amount</span>
              <span class="buffer-separator amount-separator">:</span>
              <span class="buffer-value">{{ formatCurrency(summary.bufferAmount) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Total Fund Requirement-->
      <div class="col-md-3">
        <div class="dashboard-tile card-glow">
          <div class="tile-label">Total Fund Requirement</div>
          <div class="tile-value">{{ formatCurrency(summary.fundRequirement) }}</div>
        </div>
      </div>

      <!-- Total Fund -->
      <div class="col-md-3">
        <div class="dashboard-tile card-glow">
          <div class="tile-label">Total Available Fund</div>
          <div class="tile-value">{{ formatCurrency(summary.totalReserveFund) }}</div>
        </div>
      </div>

      <!-- Total Wage Withdrawal -->
      <div class="col-md-3">
        <div class="dashboard-tile card-glow">
          <div class="tile-label">Total Earn Wage Withdrawal</div>
          <div class="tile-value negative">{{ formatCurrency(summary.totalEarnedWageWithdrawal) }}</div>
        </div>
      </div>

      <!-- Total Wallet Withdrawal -->
      <div class="col-md-3">
        <div class="dashboard-tile card-glow">
          <div class="tile-label">Total Wallet Withdrawal</div>
          <div class="tile-value negative">{{ formatCurrency(summary.totalWalletWithdrawal) }}</div>
        </div>
      </div>

      <!-- Total Income -->
      <div class="col-md-4">
        <div class="dashboard-tile card-glow">
          <div class="tile-label">Total Income</div>
          <div class="tile-value positive">{{ formatCurrency(summary.totalIncome) }}</div>
        </div>
      </div>

    </div>

    <div class="row">

      <!-- Current Balance -->
      <div class="col-md-4">
        <div class="dashboard-tile card-glow">
          <div class="tile-label">Current Balance</div>
          <div class="tile-value" [ngClass]="{'negative fund-warning': isFundBeingUsed, 'positive': !isFundBeingUsed}">
            {{ formatCurrency(summary.currentLiquidityPosition) }}
          </div>
        </div>
      </div>

      <!-- Cost of Funds -->
      <div class="col-md-4">
        <div class="dashboard-tile card-glow">
          <div class="tile-label">Cost of Funds</div>
          <div class="tile-value positive">{{ formatCurrency(summary.costOfFunds) }}</div>
        </div>
      </div>

      <!-- Utilization -->
      <div class="col-md-4">
        <div class="dashboard-tile card-glow">
          <div class="tile-label">Credit Pool Utilization</div>
          <div class="tile-value" [ngClass]="{'negative': summary.creditPoolUtilizationPercentage > 100}">
            {{ formatPercentage(summary.creditPoolUtilizationPercentage) }}
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Chart Container -->
  @if (!error) {
  <div class="chart-section">
    <div class="chart-container">
      <canvas #chartCanvas></canvas>
    </div>
  </div>
  }

  <!-- Error Message -->
  @if (error) {
  <div class="alert alert-danger alert-dismissible fade show" role="alert">
    {{ error }}
    <button type="button" class="btn-close" (click)="error = ''" aria-label="Close"></button>
  </div>
  }
</div>